/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Data_Desc4Inputs */

const en_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content scripts that read pages, background workers that stay alive, and message passing that doesn't leak.`)
};

const ar_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سكربتات محتوى تقرأ الصفحات وBackground Workers دائمة وتمرير رسائل لا يتسرب.`)
};

const bn_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পেজ পড়ার কনটেন্ট স্ক্রিপ্ট, জেগে থাকা ব্যাকগ্রাউন্ড ওয়ার্কার, আর ফাঁস না হওয়া মেসেজ পাসিং।`)
};

const de_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content-Skripte, die Seiten lesen, langlebige Background-Worker und leckfreies Message-Passing.`)
};

const es_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripts de contenido que leen páginas, background workers que se mantienen vivos y paso de mensajes sin fugas.`)
};

const fr_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripts de contenu qui lisent les pages, background workers persistants et messaging sans fuite.`)
};

const pt_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripts de conteúdo que leem páginas, background workers que permanecem ativos e passagem de mensagens sem vazamentos.`)
};

const zh_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读页面的 content script、常驻后台 worker，以及不泄漏的消息传递。`)
};

const tr_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfaları okuyan içerik betikleri, ayakta kalan arka plan worker'ları ve sızdırmayan mesaj iletimi.`)
};

const ru_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент-скрипты, читающие страницы, живучие бэкграунд-воркеры и передача сообщений без утечек.`)
};

const pl_svc_browser_extensions_data_desc4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrypty contentowe czytające strony, żywe background workery i przekazywanie wiadomości bez wycieków.`)
};

/**
* | output |
* | --- |
* | "Content scripts that read pages, background workers that stay alive, and message passing that doesn't leak." |
*
* @param {Svc_Browser_Extensions_Data_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_data_desc4 = /** @type {((inputs?: Svc_Browser_Extensions_Data_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Data_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_data_desc4(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_data_desc4(inputs)
	if (locale === "de") return de_svc_browser_extensions_data_desc4(inputs)
	if (locale === "es") return es_svc_browser_extensions_data_desc4(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_data_desc4(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_data_desc4(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_data_desc4(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_data_desc4(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_data_desc4(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_data_desc4(inputs)
	return en_svc_browser_extensions_data_desc4(inputs)
});
export { svc_browser_extensions_data_desc4 as "svc_browser-extensions_DATA_desc" }